export const distanceToString = (
  distance: number,
  options: {
    roundingMode?: 'round' | 'ceil';
    hideUnit?: boolean;
    useAreaUnit?: boolean;
  } = {}
) => {
  const {
    roundingMode = 'round',
    hideUnit = false,
    useAreaUnit = false,
  } = options;

  const division = useAreaUnit ? Math.pow(1000, 2) : 1000;

  const calc = {
    round: Math.round,
    ceil: Math.ceil,
    floor: Math.floor,
  }[roundingMode];

  return `${
    calc(distance) >= division
      ? `${calc((distance / division) * 100) / 100.0}${hideUnit ? '' : 'k'}`
      : calc(distance)
  }${hideUnit ? '' : useAreaUnit ? '㎡' : 'm'}`;
};

export const getKm2 = (num: number) => {
  if (!num) return num;

  return Math.round((Math.round(num) / Math.pow(1000, 2)) * 100) / 100;
};

export const calcWalkingSpeed = (distance: number = 0) => {
  const speed = 4000 / 60; // 분속
  return Math.round(distance / speed);
};

export const calcBicycleSpeed = (distance: number = 0) => {
  const speed = 16000 / 60; // 분속
  return Math.round(distance / speed);
};
